(() => {
  const bind = (root = document) => {
    root.querySelectorAll('[data-line-cta-link]:not([data-line-cta-bound])').forEach((link) => {
      link.dataset.lineCtaBound = 'true';

      link.addEventListener('click', () => {
        const payload = {
          source: 'homepage-line-cta',
          campaign: link.dataset.campaign || 'line-first-purchase-10',
          offer: link.dataset.offer || '10-percent-first-purchase',
          destination_host: new URL(link.href, window.location.href).host,
          page_path: window.location.pathname
        };

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'line_friend_add_click', ...payload });
        window.Shopify?.analytics?.publish?.('the_limely:line_friend_add_click', payload);
      });
    });
  };

  bind();
  document.addEventListener('shopify:section:load', (event) => bind(event.target));
})();
